import { adminSaga } from 'react-admin';

import { all } from 'redux-saga/effects';

export default function* rootSaga(dataProvider) {
  yield all([adminSaga(dataProvider)]);
}
